import { render, staticRenderFns } from "./PaymentCompleteOrdererInfo.vue?vue&type=template&id=b92f6e22&scoped=true&"
import script from "./PaymentCompleteOrdererInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentCompleteOrdererInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCompleteOrdererInfo.vue?vue&type=style&index=0&id=b92f6e22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92f6e22",
  null
  
)

export default component.exports